module.exports = __webpack_public_path__ + "img/0006.f40870c1.jpg";